module.exports = __webpack_public_path__ + "static/img/RAPS450_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAPS450_1.png
// module id = 1PLu
// module chunks = 0